import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty-video-showcase',
  templateUrl: './empty-video-showcase.component.html',
  styleUrls: ['./empty-video-showcase.component.scss']
})
export class EmptyVideoShowcaseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
